import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* technicianVideoRequestsFetchVideoRequestsListSaga(action) {

    yield put(actions.technicianVideoRequestsFetchVideoRequestsListStart());


    try {
        const response = yield axios.get(api.technicianVideoRequestsFetchVideoRequestsList);
        console.log(response.data);
        yield put(actions.technicianVideoRequestsFetchVideoRequestsListSuccess(response.data));
    } catch (error) {
        if(error.response) {
            yield put(actions.technicianVideoRequestsFetchVideoRequestsListFail(error.response.data.error));
        }else {
            yield put(actions.technicianVideoRequestsFetchVideoRequestsListFail("There's an error!"));
        }
    }

}